import { Plus, Trash2 } from 'lucide-react';

/**
 * Inline editor for MenuItem.customisation_options.
 * Manages spice_levels, portions and addons as arrays of {key, label, price_delta, icon}.
 */
export function CustomisationEditor({ value, onChange }) {
  const cfg = value || { spice_levels: [], portions: [], addons: [] };

  const update = (section, next) => onChange({ ...cfg, [section]: next });

  const addRow = (section) => {
    const emptyRow = { key: `opt_${Date.now()}`, label: '', price_delta: 0, icon: null };
    update(section, [...(cfg[section] || []), emptyRow]);
  };

  const removeRow = (section, idx) => update(section, cfg[section].filter((_, i) => i !== idx));

  const updateRow = (section, idx, field, val) => {
    const rows = [...cfg[section]];
    rows[idx] = { ...rows[idx], [field]: field === 'price_delta' ? Number(val) || 0 : val };
    update(section, rows);
  };

  const renderSection = (section, title, showIcon) => (
    <div className="bg-bgsecondary rounded-xl p-3">
      <div className="flex justify-between items-center mb-2">
        <h4 className="font-heading font-semibold text-sm text-textprimary">{title}</h4>
        <button type="button" onClick={() => addRow(section)} data-testid={`customisation-add-${section}`} className="text-xs text-maroon flex items-center gap-1 font-heading font-semibold">
          <Plus className="w-3 h-3" /> Add
        </button>
      </div>
      <div className="space-y-2">
        {(cfg[section] || []).length === 0 && <p className="text-xs text-textsecondary font-body">None. Click Add to create.</p>}
        {(cfg[section] || []).map((row, idx) => (
          <div key={idx} className="flex gap-2 items-center bg-white p-2 rounded-lg" data-testid={`customisation-row-${section}-${idx}`}>
            {showIcon && (
              <input value={row.icon || ''} onChange={(e) => updateRow(section, idx, 'icon', e.target.value)} placeholder="🌶️" className="w-10 shrink-0 text-center text-lg border border-borderbeige rounded-lg py-1" data-testid={`custom-icon-${section}-${idx}`} />
            )}
            <input value={row.label} onChange={(e) => updateRow(section, idx, 'label', e.target.value)} placeholder="Label (e.g. Mild)" className="flex-1 min-w-0 px-2 py-1.5 border border-borderbeige rounded-lg text-sm" data-testid={`custom-label-${section}-${idx}`} />
            <div className="flex items-center gap-1 shrink-0">
              <span className="text-xs text-textsecondary">₹</span>
              <input type="number" step="1" value={row.price_delta} onChange={(e) => updateRow(section, idx, 'price_delta', e.target.value)} placeholder="0" className="w-16 px-2 py-1.5 border border-borderbeige rounded-lg text-sm" data-testid={`custom-price-${section}-${idx}`} />
            </div>
            <button type="button" onClick={() => removeRow(section, idx)} data-testid={`custom-remove-${section}-${idx}`} className="text-textsecondary hover:text-maroon shrink-0">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="space-y-3 border-t border-borderbeige pt-3">
      <div className="text-xs text-textsecondary font-body">Customisation options — leave empty to use defaults</div>
      {renderSection('spice_levels', 'Spice Levels', true)}
      {renderSection('portions', 'Portions', false)}
      {renderSection('addons', 'Add-ons', false)}
    </div>
  );
}
